export var AuthenticationStyles = {
  authenticationWrapper: {
    cursor: 'default'
  },
  authBox: {
    width: screen.width >= 1024 ? '65%' : '80%'
  },
  h1: {
    height: 'auto',
    textAlign: 'center',
    marginBottom: 5
  },
  authBoxSubtitle: {
    textAlign: 'center',
    marginBottom: 20
  },
  field: {
    textAlign: 'left',
    marginBottom: 10
  },
  input: {
    width: '100%'
  },
  helpText: {
    width: '100%',
    marginTop: 5,
    fontSize: 12
  },
  showPassword: {
    position: 'absolute',
    right: 15,
    top: 45,
    fontSize: 14
  },
  actions: {
    margin: '20px 0px'
  },
  actionsInput: {
    cursor: 'pointer',
    width: '100%'
  },
  actionLinks: {
    marginTop: 40
  },
  link: {
    padding: 0
  },
  passValidator: {
    color: '#000000',
    fontSize: 12,
    fontWeight: 700,
    width: '50%',
    padding: '5px 0px'
  },
  invalid: {
    color: '#dddddd'
  },
  companyOption: {
    marginTop: 20
  }
};